import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import trans from "../../utils";
import { Button, Space, DatePicker, Select } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import QACharts from "./ConsultantDashboardParts/QACharts";
import ConsultantRequestsTable from "./ConsultantDashboardParts/ConsultantRequestsTable";
import QAAlertsSummary from "./ConsultantDashboardParts/QAAlertsSummary";
import { useGetPOIProjectsQuery } from "../../Redux/service/POIS/POIs";
import dayjs from "dayjs";

const QADashboard = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [fromDate, setFromDate] = useState(dayjs().startOf("month"));
  const [toDate, setToDate] = useState(dayjs().endOf("month"));
  const [selectedType, setSelectedType] = useState("all");
  const [selectedProject, setSelectedProject] = useState("all");

  // Get projects for filter
  const { data: projectsData } = useGetPOIProjectsQuery();

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prev) => prev + 1);
      setLastUpdated(new Date());
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
    setFromDate(dayjs().startOf("month"));
    setToDate(dayjs().endOf("month"));
    setLastUpdated(new Date());
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates.length > 0) {
      setFromDate(dates[0]);
      setToDate(dates[1]);
    } else {
      setFromDate(null);
      setToDate(null);
    }
  };

  // Types options - based on the API data structure (IR, MIR, etc.)
  const typeOptions = [
    { value: "all", label: trans("All Types") },
    { value: "IR", label: "IR" },
    { value: "MIR", label: "MIR" },
    { value: "Snag", label: trans("Snag") },
    { value: "Submittal", label: trans("Submittal") },
  ];

  // Projects options
  const projectOptions = [
    { value: "all", label: trans("All Projects") },
    ...(projectsData?.data || projectsData || []).map((project) => ({
      value: project.id || project._id,
      label: project.name || project.title,
    })),
  ];

  return (
    <div>
      <Helmet>
        <title>{trans("QA Dashboard")}</title>
        <meta
          name="description"
          content={trans(
            "QA Dashboard for managing field operations, technicians, and service requests"
          )}
        />
      </Helmet>

      {/* Dashboard Header */}
      <div
        className="d-flex justify-content-between align-items-center mb-4 p-3"
        style={{ background: "#FFFFFFDE" }}
      >
        <div>
          <h2 className="fs-24 fw-700 neutral-800 mb-1">
            {trans("Dashboard")}
          </h2>
          <p className="fs-14 neutral-500 mb-0">
            {trans("Last updated:")} {lastUpdated.toLocaleTimeString()}
          </p>
        </div>
        <Space>
          {/* <DatePicker.RangePicker
            onChange={handleDateRangeChange}
            placeholder={[trans("Start Date"), trans("End Date")]}
            style={{ width: 250 }}
            value={fromDate && toDate ? [fromDate, toDate] : []}
          />
          <Select
            value={selectedType}
            onChange={setSelectedType}
            style={{ width: 150 }}
            placeholder={trans("Type")}
          >
            {typeOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
          <Select
            value={selectedProject}
            onChange={setSelectedProject}
            style={{ width: 200 }}
            placeholder={trans("Project")}
            loading={!projectsData}
          >
            {projectOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select> */}
          <Button
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            type="default"
          >
            {trans("Refresh")}
          </Button>
        </Space>
      </div>

      {/* Alert Summary - Top Priority */}
      <div style={{ background: "#FFFFFFDE" }} className="p-3">
        <div className="mb-4">
          <QAAlertsSummary
            key={`qa-alerts-${refreshKey}`}
            refreshKey={refreshKey}
            fromDate={fromDate}
            toDate={toDate}
            type={selectedType}
            projectId={selectedProject}
          />
        </div>

        {/* Charts Section */}
        <div className="mb-4">
          <QACharts
            key={`qa-charts-${refreshKey}`}
            refreshKey={refreshKey}
            fromDate={fromDate}
            toDate={toDate}
            type={selectedType}
            projectId={selectedProject}
          />
        </div>

        {/* Latest Requests Table */}
        {/* <div className="mb-4">
          <ConsultantRequestsTable
            key={`qa-requests-${refreshKey}`}
            refreshKey={refreshKey}
          />
        </div> */}
      </div>
    </div>
  );
};

export default QADashboard;
